module.exports = __webpack_public_path__ + "static/media/Quicksand_Bold_Oblique.d1c61756.otf";